// @ts-nocheck

import { UserActionTypes } from '../../../types/actions/user';

export const setUserMissionsModerator = ({ missionsModerator }) => ({
  type: UserActionTypes.SET_MISSIONS_MODERATOR,
  payload: {
    missionsModerator,
  },
});

export const setUserPromotionStatus = ({ promotionStatus }) => ({
  type: UserActionTypes.SET_PROMOTION_STATUS,
  payload: {
    promotionStatus,
  },
});
